import axios from 'axios'
import React, { useState } from 'react'
import authService from '../../../Components/Login/auth.service'
//const uuidv4 = require('uuid/v4')

export default function Modal() {
  var user = authService.getCurrentUser()
  const [modal, setModal] = useState(false)
  const uuidv4 = window.crypto && window.crypto.randomUUID ? window.crypto.randomUUID() : Date.now().toString(16) + '-' + Math.random().toString(16).slice(2);

  const toggleModal = () => {
    setModal(!modal)
  }

  if (modal) {
    document.body.classList.add('active-modal')
  } else {
    document.body.classList.remove('active-modal')
  }
  let newDate = new Date()

  const [campos, setCampos] = useState({
    IdTipoDocumento: '',
    IdEmpresa: user[0].IdEmpresa,
    tpdDescricao: '',
    tpdStatus: 1,
    tpdObservacoes: '',
    tpdCriadoPor: user[0].pesEmail,
    tpdCriadoEm: newDate,
    tpdAlteradoPor: user[0].pesEmail,
    tpdAlteradoEm: newDate,
    tpdCodigoGUID: uuidv4
  })
  function handleInputChange(event) {
    if (event.target.name === 'tpdStatus') {
      if (event.target.checked) {
        campos[event.target.name] = 1
      } else {
        campos[event.target.name] = 0
      }
    } else {
      campos[event.target.name] = event.target.value
    }
    setCampos(campos)
  }
  function handleFormSubmit(event) {
    event.preventDefault()
    axios
      .post(process.env.REACT_APP_API_URL + '/api/v1/tipodocumento', campos)
      .then(response => {
        alert(response.data.message)
        window.location.reload()
      })
  }
  return (
    <>
      <button onClick={toggleModal} className="buttonModalPadraoPes1">
        Novo Tipo de Documento
      </button>

      {modal && (
        <div className="modalArea">
          <div onClick={toggleModal} className="overlay"></div>
          <div className="modalPadrao-content">
            <div className="cxTituloPadrao">
              <h1>
                Novo Tipo de Documento
                <hr className="hrTitleModal" />
              </h1>
              <button onClick={toggleModal}>X</button>
            </div>

            <form onSubmit={handleFormSubmit}>
              <label>Descrição:</label>
              <input
                placeholder="Descrição"
                type="text"
                id="fname"
                defaultValue={campos.tpdDescricao}
                name="tpdDescricao"
                onChange={handleInputChange}
              ></input>

              <label>Observações:</label>
              <textarea
                placeholder="Observações"
                type="text"
                id="fname"
                name="tpdObservacoes"
                defaultValue={campos.tpdObservacoes}
                row="none"
                onChange={handleInputChange}
                maxLength="500"
              ></textarea>
              <div className="caixaSalvarPadrao">
                <div className="InputAuthorization4">
                  <label>
                    <input
                      name="tpdStatus"
                      type="checkbox"
                      defaultChecked={!!campos.tpdStatus}
                      onChange={handleInputChange}
                    />
                    <span>Status</span>
                  </label>
                </div>
                <button type="submit">Salvar Registro</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </>
  )
}
